import { SharkIcon } from './SharkIcon';

/**
 * author: Colton Wiscombe
 * id 4D7D5865-0AEE-40A3-9015-86661A60DA8C
 * name shark
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shark.svg
 * tags
 * - Animal 
 */
export const JawsIcon = SharkIcon;
export default JawsIcon